module.exports = __webpack_public_path__ + "img/eligibilite4.21d1914e.jpg";